let base_url = process.env.REACT_APP_BASE_URL
export const endpoints = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    app: {
        init: '/init',
        verifyOtp: '/verifyOtp',
    },
    user: {
        getUser: '/users',
        validateToken: '/validateToken'
    },
    login: {
        myzone: '/myzoneValiateUser',
        userlog: `/userLog`,
        validateUser: '/validateUser',
        loginAttempt: '/loginAttempt',
        getStratergy: '/getStratergy',
        reportSend: '/reportSend',
        logout: '/logout',
        logoutNew: '/login/logout',
        GetAccountPerformance: "/GetAccountPerformance",
        GetCapitalMovement: '/GetCapitalMovement',
        GetCorporateAction: '/GetCorporateAction',
        GetDebitNote: '/GetDebitNote',
        GetTaxaibleGain: '/GetTaxaibleGain',
        GetHoldingStatement: '/GetHoldingStatement',
        bitlyLink: '/bitlyLink',
        GetAuditReportYears: '/GetAuditReportYears',
        GetAuditReport: '/GetAuditReport',
        GetQueryCategory: '/GetQueryCategory',
        GetQuerySubCategory: '/GetQuerySubCategory',
        RaiseQueryClientMF: '/RaiseQueryClientMF',
        RaiseQueryClientPMS: '/RaiseQueryClientPMS',
        RaiseQuery: '/RaiseQuery',
        GetAuditStratergy: '/GetAuditReportStrategy',
        RaiseQueryClientAIF: '/RaiseQueryClientAIF',
        GetAccountStatement: '/GetAccountStatement',
        ClientAIF: '/ClientAIF',
        ClientMF: '/ClientMF',
        GetMFAccountStatement: '/GetMFAccountStatement',
        GetMFcapitalGainLoss: '/GetMFcapitalGainLoss',
        GetRaiseQuery: '/GetRaiseQuery',
        RaiseQueryAdminRole: '/RaiseQueryAdminRole',
        PMSDistibutorLogin: '/PMSDistibutorLogin',
        PMSGenerateOtp: '/pmsGenerateOTP',
        ResetForgetPassword: '/ResetForgetPassword',
        AIFDistibutorLogin: '/AIFDistibutorLogin',
        ResetForgetPasswordAIF: '/ResetForgetPasswordAIF',
        CheckAIFDITPan: '/CheckAIFDITPan',
        CheckPMSDITPan: '/CheckPMSDITPan',
        GetDITUserDetails: '/GetDITUserDetails',
        PMSGetAuditReportStrategy: '/PMSGetAuditReportStrategy',
        GetAccountPerformanceGroupwis: '/GetAccountPerformanceGroupwis',
        GetFractionLedger: '/',
        CheckMFPanDist: '/CheckMFPanDist',
        GetDITAuthToken: '/c/silentLogin/GetDITAuthToken',
        // authenticateUserByPan: '/CommonDistributorLogin',
        // authenticateUserByToken: '/CommonDistributorToken',
        common: `/login/common`,
        GetFundDetails: '/c/inav/GetFundDetails',
        AddNAVDetails: '/c/inav/AddNAVDetails',
        GetNAVHistoryDetails: '/c/inav/GetNAVHistoryDetails',
        MissedUpdateAlert: '/c/inav/MissedUpdateAlert',
    },
    dashboard: {
        GETPMSDITDashboard: '/GETPMSDITDashboard',
        GETPMSDITCommissionTrendYTD: '/GETPMSDITCommissionTrendYTD',
        GETPMSDITActiveYear: '/GETPMSDITActiveYear',
        GETPMSDITSalesOverViewMTD: '/GETPMSDITSalesOverViewMTD',
        GETPMSDITAUMTrendYTD: '/GETPMSDITAUMTrendYTD',
        GETPMSDITInvestorTrendYTD: '/GETPMSDITInvestorTrendYTD',
        GETPMSDITSalesOverViewYTD: '/GETPMSDITSalesOverViewYTD',
    },
    reports: {
        GetFractionLedger: "/GetFractionLedger",
        PMSRealisedCapitalGainLossReport: '/PMSRealisedCapitalGainLossReport',
        GetAUM: "/c/reports/GetAUM",
        GetInvestmentDistributionStatement: "/c/reports/GetInvestmentDistributionStatement",
        GetBalanceSheet: '/c/reports/GetBalanceSheet',
        GetBankBook: '/c/reports/GetBankBook',
        GetBrokerLedger: '/c/reports/GetBrokerLedger',
        GetClientInfo: '/c/reports/GetClientInfo',
        GetCustodianFeesLedger: '/c/reports/GetCustodianFeesLedger',
        GetExitLoadLedger: '/c/reports/GetExitLoadLedger',
        GetIncomeExpenseStatment: '/c/reports/GetIncomeExpenseStatment',
        PMSManagementFeesLedger: '/c/reports/PMSManagementFeesLedger',
        PMSUpfrontFeesPayableLedger: '/c/reports/PMSUpfrontFeesPayableLedger',//fees payable
        accountStatementInvApi: '/c/reports/accountStatementInvApi',//Account Statement for Investor Api
        GetLedgerAccount: '/c/reports/GetLedgerAccount',//fees payable
        PMSTransactionStatementReport: '/c/reports/PMSTransactionStatementReport',
        GetPMSWelcomeLetter: '/c/reports/GetPMSWelcomeLetter',
        PMSSecuritiesTransactionTax: '/c/reports/PMSSecuritiesTransactionTax',
        PMSProfitLoss: '/c/reports/PMSProfitLoss',
        GetPerformanceFeesCalculation: '/c/reports/GetPerformanceFeesCalculation',
        PMSPerformanceBasedFeesLedger: '/c/reports/PMSPerformanceBasedFeesLedger',
        PMSMovementOfCorpus: '/c/reports/PMSMovementOfCorpus',
        GetMISMonth: '/c/reports/GetMISMonth',
        MISReport: '/c/reports/MISReport',
        GetAccountPerMerger: '/c/reports/GetAccountPerMerger',
        GetOnePager: '/c/reports/GetOnePager',
        GetCAGRReport: '/c/reports/GetCAGRReport'
    },
    dirReports: {
        getDitReportList: `/getDitReportList`,
        submitDitReport: `/submitDitReport`,
        addReportIssueData: '/addReportIssueData',
        addSuggestionData: '/addSuggestionData',
        uploadFeedbackFile: 'uploadFeedbackFile',
        GetAccountPerMerger: '/c/reports/GetAccountPerMerger'
    },
    dirReports: {
        getDitReportList: `/getDitReportList`,
        submitDitReport: `/submitDitReport`,
        addReportIssueData: '/addReportIssueData',
        addSuggestionData: '/addSuggestionData',
        uploadFeedbackFile: 'uploadFeedbackFile',
    }
}